module.exports = __webpack_public_path__ + "static/media/bruce5.4579b9c7.mp3";